export default "__VITE_ASSET__q_kwF64___"